import { Permiso } from "../shared/model/permisos/permiso.model";

/**
 * El filtro de «Tus permisos»: un estado, TODOS cuando no hay ninguno
 * prendido, o ARCHIVADOS. Los retirados sin archivar sólo salen sin filtro;
 * los archivados (14/10/2026) sólo en «Archivados».
 */
export type FiltroPermisos = "TODOS" | "PENDIENTE" | "AUTORIZADO" | "RECHAZADO" | "ARCHIVADOS";

/** Cuántos hay de cada filtro. Los archivados no cuentan en los demás. */
export function cuentaPermisos(mios: Permiso[]): Record<FiltroPermisos, number> {
  const c: Record<FiltroPermisos, number> = { TODOS: 0, PENDIENTE: 0, AUTORIZADO: 0, RECHAZADO: 0, ARCHIVADOS: 0 };
  for (const p of mios) {
    if (p.archivado) {
      c.ARCHIVADOS++;
      continue;
    }
    c.TODOS++;
    if (p.estatus === "PENDIENTE" || p.estatus === "AUTORIZADO" || p.estatus === "RECHAZADO") {
      c[p.estatus]++;
    }
  }
  return c;
}

/** Los de un filtro: los archivados sólo salen en «Archivados», y ahí sólo ellos. */
export function filtraPermisos(mios: Permiso[], filtro: FiltroPermisos): Permiso[] {
  if (filtro === "ARCHIVADOS") {
    return mios.filter((p) => p.archivado);
  }
  const aLaVista = mios.filter((p) => !p.archivado);
  return filtro === "TODOS" ? aLaVista : aLaVista.filter((p) => p.estatus === filtro);
}
